var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentage = function SvgPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#percentage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-165-1515h1440V612H-165z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#58B847"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.604 23.358a1.25 1.25 0 0 0-1.248 1.248c0 .688.56 1.248 1.248 1.248a1.25 1.25 0 0 0 1.248-1.248 1.25 1.25 0 0 0-1.248-1.248ZM18.383 17.138a1.25 1.25 0 0 0-1.248 1.248c0 .688.56 1.248 1.248 1.248a1.25 1.25 0 0 0 0-2.496Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 21.5c0-5.928 4.822-10.75 10.75-10.75s10.75 4.822 10.75 10.75c0 5.927-4.822 10.75-10.75 10.75S10.75 27.427 10.75 21.5Zm10.226-3.114a2.596 2.596 0 0 0-2.593-2.593 2.596 2.596 0 0 0-2.594 2.593 2.596 2.596 0 0 0 2.594 2.593 2.596 2.596 0 0 0 2.593-2.593Zm-3.382 7.97a.67.67 0 0 1-.95 0 .672.672 0 0 1 0-.95l8.762-8.763a.672.672 0 0 1 .95.951l-8.762 8.762Zm4.416-1.75a2.596 2.596 0 0 0 2.593 2.593 2.596 2.596 0 0 0 2.593-2.593 2.596 2.596 0 0 0-2.593-2.593 2.596 2.596 0 0 0-2.593 2.593Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "percentage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-165 -1515)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgPercentage;